/**
 * Admin layout — chrome shared by every admin route.
 *
 *   ┌──────────────────────────────────────────────────┐
 *   │ TopBar                                           │  48px
 *   ├─────────┬────────────────────────────────────────┤
 *   │         │  OpenAINotConfiguredBanner (if shown)  │
 *   │ Sidebar │  Page content (route Outlet)           │
 *   │ 280px   │                                        │
 *   └─────────┴────────────────────────────────────────┘
 *
 * The sidebar collapses to 64px and persists that state.
 * The command palette is mounted here and Cmd/Ctrl+K opens it.
 */
import { Suspense, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { RouteFallback } from '../../components/RouteFallback';
import { CommandPalette } from '../../components/shell/CommandPalette';
import { OpenAINotConfiguredBanner } from '../../components/shell/OpenAINotConfiguredBanner';
import { Sidebar } from '../../components/shell/Sidebar';
import { TopBar } from '../../components/shell/TopBar';

export function AdminLayout(): JSX.Element {
  const [paletteOpen, setPaletteOpen] = useState(false);
  const { pathname } = useLocation();
  // Mail is a top-bar workspace, not a left-rail module — give it the full
  // width, the same way /odoo gets it in UserLayout.
  const hideSidebar = pathname.startsWith('/admin/mail');

  return (
    <div className="fixed inset-0 flex flex-col overflow-hidden bg-paper text-ink">
      <TopBar onOpenCommandPalette={() => setPaletteOpen(true)} />
      <div className="flex min-h-0 flex-1">
        {!hideSidebar && <Sidebar />}
        <div className="flex min-h-0 min-w-0 flex-1 flex-col">
          <OpenAINotConfiguredBanner />
          <main className="min-h-0 flex-1 overflow-auto">
            <Suspense fallback={<RouteFallback />}>
              <Outlet />
            </Suspense>
          </main>
        </div>
      </div>
      <CommandPalette open={paletteOpen} onOpenChange={setPaletteOpen} />
    </div>
  );
}
